module.exports = __webpack_public_path__ + "img/vehicle_1.3d26bdfa.png";